import { Box, CircularProgress } from "@mui/material";
import logo from "assets/tea-logo.png";

function FullPageLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh",
        gap: 4,
      }}
    >
      <img
        src={logo}
        alt="Travel & Expenses Assistant"
        style={{
          width: "200px",
          height: "200px",
        }}
      />
      <CircularProgress />
    </Box>
  );
}

export default FullPageLoader;
